import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getLength, getSpacing, createStyleFunction } from 'utils/ui';
export var alignMap = {
  top: 'flex-start',
  left: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
  right: 'flex-end',
  stretch: 'stretch',
  baseline: 'baseline'
};
var distributedAlignMap = _objectSpread(_objectSpread({}, alignMap), {}, {
  'space-between': 'space-between',
  'space-around': 'space-around',
  'space-evenly': 'space-evenly'
});

// TODO: extend with CSSProperties["alignContent"]

export var flexPropsDef = [{
  styleProp: 'flexWrap',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'wrapItems',
  properties: ['flexWrap'],
  getValue: function getValue(value) {
    return value ? 'wrap' : 'nowrap';
  }
}, {
  styleProp: 'basis',
  properties: ['flexBasis'],
  getValue: getLength
}, {
  styleProp: 'grow',
  properties: ['flexGrow'],
  getValue: function getValue(value) {
    return Number(value);
  }
}, {
  styleProp: 'shrink',
  properties: ['flexShrink'],
  getValue: function getValue(value) {
    return Number(value);
  }
}, {
  styleProp: 'flexAlign',
  properties: ['alignSelf'],
  getValue: function getValue(value) {
    return alignMap[value] || value;
  }
}, {
  styleProp: 'alignItems',
  getValue: function getValue(value) {
    return alignMap[value] || value;
  }
}, {
  styleProp: 'justifyContent',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'justifySelf',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'flexDirection',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'stackItems',
  properties: ['flexDirection'],
  getValue: function getValue(value) {
    return value ? 'column' : 'initial';
  }
}, {
  styleProp: 'gridArea',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'gridColumn',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'gridRow',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'gap',
  getValue: getSpacing
}, {
  styleProp: 'rowGap',
  getValue: getSpacing
}, {
  styleProp: 'columnGap',
  getValue: getSpacing
}];
export var baseFlexRules = {
  /* Reset flex */
  flex: 'none',
  /* Prevent overflowing content from expanding flex items */
  minWidth: 0
};
var flexProps = createStyleFunction(flexPropsDef, baseFlexRules);
export default flexProps;